<template>
  <div class="svj-scheme__card" @click="showDetail(scheme)">
    <div class="svj-card__img__container cursor-pointer">
      <div
        class="svj-card__roam__container cursor-pointer"
        v-if="scheme.render720ViewUrl"
        @click.stop="toRoam(scheme.render720ViewUrl)"
      >
        <i class="svj-icon__roam"></i>
        <span class="svj-card__roam__text">全屋漫游</span>
      </div>
      <img :src="scheme.mainImageUrl" class="svj-card__img" />
    </div>
    <div class="svj-card__body">
      <p class="svj-card__title">{{scheme.schemeName}}</p>
      <p class="svj-card__content">
        <img class="svj-card__avatar" :src="scheme.avatar" @error="handleAvatarError" />
        <span class="svj-card__designer text-ellipsis">{{scheme.author}}</span>
        <span class="svj-card__views">
          <i class="svj-icon__views"></i>
          <span class="svj-card__views__text">{{scheme.totalView}}</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
export default {
  name: 'SchemeCard',
  props: ['scheme'],
  methods: {
    showDetail() {
      this.$emit('showDetail');
    },
    toRoam(url) {
      window.open(url, '_blank');
    },
    handleAvatarError(e) {
      e.target.src = 'https://3vj-fe.3vjia.com/common/images/default-avatar.png?x-oss-process=image/resize,m_fill,h_24,w_24';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/mixins/mobile.scss';

.svj-icon__views {
  background-image: url("~@/assets/plugin/icon/views.png");
  background-size: cover;
  display: inline-block;
  opacity: 0.5;
  width: vw(16);
  height: vw(16);
  vertical-align: -vw(3);
}
.svj-icon__roam {
  background-image: url("~@/assets/plugin/icon/roam.png");
  background-size: contain;
  display: inline-block;
  width: vw(20);
  height: vw(20);
}
.svj-scheme__card {
  width: vw(335);
  margin-top: vw(20);
  background-color: white;
  border-radius: vw(4);
  overflow: hidden;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px vw(4) vw(20) 0px rgba(0, 0, 0, 0.1);
  }
  .svj-card__roam__container {
    display: flex;
  }
  .svj-card__img__container {
    position: relative;
    height: vw(190);
    .svj-card__roam__container {
      position: absolute;
      top: vw(12);
      right: vw(12);
      width: vw(120);
      height: vw(48);
      background: rgba(0, 0, 0, 0.5);
      border-radius: vw(4);
      justify-content: center;
      align-items: center;
      .svj-card__roam__text {
        padding-left: vw(3);
        font-size: vw(16);
        font-weight: 400;
        color: #ffffff;
        line-height: vw(22);
      }
    }
    .svj-card__img {
      width: 100%;
      height: 100%;
    }
  }
  .svj-card__body {
    padding: vw(16) vw(20);
    font-size: vw(14);
    .svj-card__title {
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: vw(20);
      margin-bottom: vw(12);
    }
    .svj-card__content {
      margin-bottom: 0;
    }
    .svj-card__avatar {
      width: vw(24);
      height: vw(24);
      border-radius: 100%;
      margin-right: vw(8);
    }
    .svj-card__designer {
      max-width: vw(200);
      font-weight: 400;
      color: #999999;
      line-height: vw(23);
    }
    .svj-card__views {
      float: right;
      .svj-card__views__text {
        padding-left: vw(5);
        color: #999999;
        line-height: vw(12);
      }
    }
  }
}
</style>
